import {editableAnatomy as parts} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

import {semantic as dark, components as darkComponents} from '../../design-tokens/dark';
import {core, semantic, components} from '../../design-tokens/light';
import {getCoreValueAsThemeToken} from '../types';

const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(parts.keys);

const sharedStyles = defineStyle({
  fontSize: `inherit`,
  fontWeight: `inherit`,
  textAlign: `inherit`,
  bg: `transparent`,
});

const baseStylePreview = defineStyle({
  ...sharedStyles,
  // margin: getCoreValueAsThemeToken(core, `space.space-100`),
  // width: `full`,
  // borderRadius: getCoreValueAsThemeToken(core, `radii.radius-100`),
  // padding: getCoreValueAsThemeToken(core, `space.space-150`),
});

const baseStyleInput = defineStyle(props => ({
  ...sharedStyles,
  borderRadius: getCoreValueAsThemeToken(core, `radii.radius-100`),
  // TODO: replace with token
  borderWidth: `1px`,
  borderColor: mode(semantic.colors.stroke.primary, dark.colors.stroke.secondary)(props),
  backgroundColor: mode(
    components.colors.components[`form-control`][`background-default`],
    darkComponents.colors.components[`form-control`][`background-default`],
  )(props),
  outline: 0,
  padding: getCoreValueAsThemeToken(core, `space.space-150`),
  gap: getCoreValueAsThemeToken(core, `space.space-050`),
}));

const baseStyleTextarea = defineStyle({
  ...sharedStyles,
  outline: 0,
  borderRadius: `md`,
  py: `1`,
  transitionProperty: `common`,
  transitionDuration: `normal`,
  width: `full`,
  _focusVisible: {boxShadow: `outline`},
  _placeholder: {opacity: 0.6},
});

const baseStyle = definePartsStyle(props => ({
  preview: baseStylePreview,
  input: baseStyleInput(props),
  textarea: baseStyleTextarea,
}));

export const editableTheme = defineMultiStyleConfig({
  baseStyle,
});
